// ===========================================
// SCHEMA: AlertaVencimiento (ORR-232)
// ===========================================
// Schema Zod para programar una alerta sobre un vencimiento puntual

import { z } from 'zod'

export const alertaVencimientoSchema = z.object({
  dias_antes: z
    .number()
    .int('Los días deben ser un número entero')
    .min(0, 'No puede ser negativo')
    .max(60, 'El máximo es 60 días'),
  alcance: z.enum(['solo_proximo', 'todos_los_siguientes']),
})

export type AlertaVencimientoFormValues = z.infer<typeof alertaVencimientoSchema>
